import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
  DELAY_FILTER_TIME,
} from "constants/RemoteDataTableContanst";
import { ROLE_APP } from "constants/actionAccess";
import { convertDateTime, formatDateTime } from "helpers/utils";
import { useDeleteHoliday, useListHoliday } from "hooks/holiday/useHoliday";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { customFilter, textFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import {
  Button,
  Card,
  CardBody,
  Col,
  Modal,
  ModalHeader,
  Row,
  Label,
} from "reactstrap";
import { Switch } from "antd";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import BreadcrumbWithLink from "../../components/Common/BreadcrumbWithLink";
import ConfirmModal from "../../components/shared-components/ConfirmModal";
import RemoteDataTable from "../../components/shared-components/RemoteTable/data-table";
import HolidayForm from "./HolidayForm";
import { getInitHolidayParams } from "./utils";
import useUserList from "pages/RouteManagement/useUserList";
import CustomSelectFilter from "components/shared-components/RemoteTable/custom-select-filter";

const ListHoliday = () => {
  const { t } = useTranslation(["holiday"]);
  const [isLogAdmin, setIsLogAdmin] = useState(false);
  const [isHubAdmin, setIsHubAdmin] = useState(true);
  const { optionUserScan } = useUserList();
  const initColumns = [
    {
      dataField: "hub_id",
      text: "Center/Hub",
      sort: true,
      formatter: (cell, row) => {
        return row?.hub?.name;
      },
    },
    {
      dataField: "name",
      text: t("table.name"),
      sort: false,
      allowExport: true,
    },
    {
      dataField: "from_date",
      text: t("table.from_date"),
      sort: false,
      allowExport: true,
      formatter: (cell, row) => {
        if (cell) {
          return convertDateTime(cell, formatDateTime.DD_MM_YYYY);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={holidayParams.columnFilter}
        />
      ),
    },
    {
      dataField: "maker_id",
      text: t("table.maker_id"),
      formatter: (cell, row) => {
        return row.maker && row.maker.display_name
          ? row.maker.display_name
          : cell;
      },
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomSelectFilter
          onFilter={onFilter}
          column={column}
          paramFilter={holidayParams.columnFilter}
          dataSelect={optionUserScan}
          placeholder={t("placeholder.select")}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "maker_date",
      text: t("table.maker_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return convertDateTime(cell, formatDateTime.DD_MM_YYYY);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={holidayParams.columnFilter}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "checker_id",
      text: t("table.checker_id"),
      formatter: (cell, row) => {
        return row.checker && row.checker.display_name
          ? row.checker.display_name
          : cell;
      },
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomSelectFilter
          onFilter={onFilter}
          column={column}
          paramFilter={holidayParams.columnFilter}
          dataSelect={optionUserScan}
          placeholder={t("placeholder.select")}
        />
      ),
      allowExport: true,
    },
    {
      dataField: "checker_date",
      text: t("table.checker_date"),
      sort: true,
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }).format(Number(cell) * 1000);
        } else {
          return "";
        }
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={holidayParams.columnFilter}
        />
      ),
    },
  ];

  const [columnsTable, setColumnsTable] = useState(initColumns);
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [openModalUpdate, setOpenModalUpdate] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [updatingHoliday, setUpdatingHoliday] = useState(null);
  const [deletingHoliday, setDeletingHoliday] = useState(null);
  const [holidayParams, setHolidayParams] = useState(getInitHolidayParams);

  const {
    data: holidays,
    isFetching: isLoadingList,
    refetch: fetchHolidays,
  } = useListHoliday({ params: holidayParams });

  // const [is_level_2, setIsLevel2] = useState(true);
  // const handleChangeIsLevel2 = value => {
  //   setIsLevel2(value);
  //   // setHolidayParams(prev => ({
  //   //   ...prev,
  //   //   columnFilter: {
  //   //     ...prev.columnFilter,
  //   //     "filter[hub_id]": null,
  //   //   },
  //   //   page: 1,
  //   //   run: true,
  //   // }));
  // };

  useEffect(() => {
    if (holidayParams && holidayParams?.run) {
      fetchHolidays();
    }
  }, [holidayParams, holidayParams?.run]);

  // When Data Use For Table Changed
  useEffect(() => {
    if (holidays) {
      initColumn();
    }
  }, [holidays, optionUserScan]);

  const initColumn = () => {
    setColumnsTable(initColumns);
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    setHolidayParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : holidayParams.sort,
      columnFilter:
        {
          ...prev.columnFilterKeep,
          ...columnFilter,
        } || {},
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };
  const onSearchAllHandle = value => {
    console.log(value);
    setHolidayParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const { mutate: deleteHoliday } = useDeleteHoliday(fetchHolidays);
  const handleDelete = () => {
    deleteHoliday(deletingHoliday.id);
    setOpenModalDelete(false);
  };

  const listRowAction = [
    {
      isShow: isLogAdmin,
      icon: <i className="fas fa-pen fa-lg text-primary" />,
      text: t("table.actions.update"),
      onClick: row => {
        setUpdatingHoliday(row);
        setOpenModalUpdate(true);
      },
    },
    {
      isShow: isLogAdmin,
      icon: <i className="fas fa-trash fa-lg text-danger" />,
      text: t("table.actions.delete"),
      onClick: row => {
        setDeletingHoliday(row);
        setOpenModalDelete(true);
      },
    },
  ];

  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const listRole = info["auth"].split(",");
    setIsHubAdmin(
      listRole.find(item => item.includes(ROLE_APP.ROLE_HUB_ADMIN))
        ? true
        : false || false
    );
    setIsLogAdmin(
      listRole.find(item => item.includes(ROLE_APP.ROLE_LOG_ADMIN))
        ? true
        : false || false
    );
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{t("title.list")}</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.list") + ` (${holidays?.totalCount || 0})`}
            breadcrumbItems={[
              { name: t("title.holiday") },
              { name: t("title.list") },
            ]}
          />
          <Modal size="lg" isOpen={openModalUpdate} centered>
            <ModalHeader
              toggle={() => {
                setOpenModalUpdate(false);
              }}
            >
              Cập nhật ngày nghỉ
            </ModalHeader>
            <HolidayForm
              holiday={updatingHoliday}
              onSuccess={() => {
                setOpenModalUpdate(false);
                fetchHolidays();
              }}
            />
          </Modal>
          <Modal size="lg" isOpen={openModalCreate} centered>
            <ModalHeader
              toggle={() => {
                setOpenModalCreate(false);
              }}
            >
              Tạo ngày nghỉ
            </ModalHeader>
            <HolidayForm
              onSuccess={() => {
                setOpenModalCreate(false);
                fetchHolidays();
              }}
            />
          </Modal>
          <ConfirmModal
            isOpen={openModalDelete}
            titleHeader={t("action.delete.title")}
            titleBody={`
                        ${t("action.delete.description", {
                          code: deletingHoliday?.code,
                        })} ?`}
            onConfirm={handleDelete}
            textBtnConfirm={t("button.confirm")}
            textBtnCancel={t("button.cancel")}
            toggle={() => setOpenModalDelete(false)}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {columnsTable.length > 0 && (
                    <RemoteDataTable
                      // selectRow={selectRowCheckbox}
                      keyField="id"
                      data={holidays?.items || []}
                      columns={columnsTable}
                      page={holidayParams.page}
                      sizePerPage={holidayParams.sizePerPage}
                      totalSize={holidays?.totalCount || 0}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      listRowAction={listRowAction}
                      loading={isLoadingList}
                    >
                      <div className="d-flex gap-2">
                        {/* <Label
                          className="md-0"
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            marginBottom: "0px",
                            alignItems: "center",
                          }}
                          htmlFor="is_level_2"
                          onClick={() => handleChangeIsLevel2(!is_level_2)}
                        >
                          <Switch
                            checked={is_level_2}
                            onChange={handleChangeIsLevel2}
                          />
                          Địa chỉ 2 cấp
                        </Label> */}
                        <HubFilter
                          mainFilterParams={holidayParams}
                          setMainFilterParams={setHolidayParams}
                          isNotFilterChildHub={true}
                          isHaveAllOption={true}
                          isFilterAllDefault={true}
                          handleChangeHub={hubId => {
                            setHolidayParams(prev => ({
                              ...prev,
                              columnFilter: {},
                              page: 1,
                              run: true,
                            }));
                          }}
                          addressLevel={3}
                        />
                        {isLogAdmin && (
                          <Button
                            onClick={() => setOpenModalCreate(true)}
                            color="primary"
                            className="btn-label me-2"
                            type="button"
                          >
                            <i className="fas fa-plus label-icon" />
                            {t("title.create")}
                          </Button>
                        )}
                      </div>
                    </RemoteDataTable>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListHoliday;
